<template>
  <div v-if="coverImageUrl" class="mb-8">
    <img
      :src="coverImageUrl"
      alt="Обложка квартиры"
      class="rounded-lg shadow-md object-cover mx-auto"
      :style="{ width: width, height: height }"
    />
  </div>
</template>

<script setup>
defineProps({
  coverImageUrl: {
    type: String,
    required: true
  },
  width: {
    type: String,
    default: '100%' // можно '400px' например
  },
  height: {
    type: String,
    default: '100%' // можно '300px' например
  }
})
</script>
